import ErrorDispatcher from './ErrorDispatcher';

export class ResultsTypeError implements ErrorDispatcher {
  public getError() {
    return new Error(
      '[ResultsTypeError] Page request have 200 status but results is not an array',
    );
  }
}
